export const TEXT_SPLIT_LENGTH = 1;
export const DEFAULT_SEARCH_LIMIT = 100;
export const SEARCH_MIN_CHARS = 0;
export const DEFAULT_SEARCH_PAGE = 1;
export const DEFAULT_SEARCH_SORTING = "-created_on";
